import React from "../../../_snowpack/pkg/react.js";
import ButtonStep from "./ButtonStep.js";
const Steps = (props) => {
  const {steps, onSelection = () => {
  }, lang} = props;
  return /* @__PURE__ */ React.createElement("div", {
    className: "Steps"
  }, lang === "fr" && /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "À quelle étape est votre projet ?"), lang === "en" && /* @__PURE__ */ React.createElement("h1", {
    className: "assistant-title"
  }, "At what stage is your project?"), /* @__PURE__ */ React.createElement("div", {
    className: "steps"
  }, steps.map((step) => /* @__PURE__ */ React.createElement(ButtonStep, {
    imgSrc: step.img,
    title: step.title,
    description: step.description,
    onClick: () => onSelection(step)
  }))));
};
export default Steps;
